import { ContractorLegalBankDetail, ContractorLegalItem, ContractorLegalSearch } from '../bus/contractorLegal/types';
import $axios from '../utils/axios-instance';

export default class ContractorLegalApi {
  async getContractorLegalList() {
    return await $axios
      .get<{ data: ContractorLegalItem[] }>('/v1/ContractorLegal')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getContractorLegalDetail(data: { id: number | string }) {
    return await $axios
      .get<ContractorLegalItem>(`/v1/ContractorLegal/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createContractorLegal(data: Omit<ContractorLegalItem, 'id'>) {
    return await $axios
      .post('/v1/ContractorLegal', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeContractorLegal(data: ContractorLegalItem) {
    return await $axios
      .put(`/v1/ContractorLegal/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteContractorLegal(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/ContractorLegal/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getContractorLegalSearch(data: { inn: string }) {
    return await $axios
      .get<ContractorLegalSearch>(`/v1/ContractorLegal/search/${data.inn}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getContractorLegalBankDetail(data: { bik: string }) {
    return await $axios
      .get<ContractorLegalBankDetail>(`/v1/ContractorLegal/SearchBankDetails/${data.bik}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
